import { getOffers } from '@view-offers/store/selectors/offers.selector';
import { getDeliveryAddress } from '@view-offers/store/selectors/offers.selector';
import { getCurrentPlan } from '@view-offers/store/selectors/current.plan.selector';
import { getContact } from '@view-offers/store/selectors/offers.selector';
import { getOffer } from '@view-offers/store/selectors/offers.selector';
import { createSelector } from '@ngrx/store';
import { Offers, CurrentPlan, Offer } from '@dgx-pr-spa/shared/util';

export const getOrderTakenData = createSelector(
  [getOffer, getContact, getCurrentPlan, getOffers, getDeliveryAddress],
  (offer, contact, currentPlan, offers, deliveryAddress) => {
    const { make, model, appliance_category, supplier_name } = (
      offers as Offers
    ).replacement_offers[0];

    const isDisposalSelected = null;
    const isInstallationSelected = null;
    const isProtectionSelected = null;

    return {
      make,
      model,
      applianceCategory: appliance_category,
      planNumber: (currentPlan as CurrentPlan).plan_number,
      deliveryDate: (offer as Offer).expected_delivery_date,
      contact,
      deliveryAddress,
      isDisposalSelected,
      isInstallationSelected,
      isProtectionSelected,
      deliveredBy: supplier_name,
    };
  }
);
